import React from 'react'
import classNames from 'classnames'
import classes from './Paper.scss'

import PaperMUI, { PaperProps } from '@mui/material/Paper'
import Typography from '@mui/material/Typography'

type CustomPaperProps = PaperProps & {
  label?: string
}
export default function Paper({ label, children, classes: paperClasses, ...props }: CustomPaperProps): JSX.Element {
  return (
    <PaperMUI
      {...props}
      classes={{
        ...paperClasses,
        root: classNames(paperClasses?.root, {
          [classes.paper]: !!label
        })
      }}
    >
      {label && (
        <Typography color="textSecondary" classes={{ root: classes.label }}>{label}</Typography>
      )}
      {children}
    </PaperMUI>
  )
}
